import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { Telescope } from '@emotion-icons/ionicons-sharp/Telescope'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 ${Shapes.spacing[4]}px;
  gap: 40px;
  overflow: hidden;
`

const Content = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: ${Colors.border};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Shapes.spacing[2]}px;
  min-height: 200px;
  padding: ${Shapes.spacing[4]}px 20%;
  text-align: center;
  border-radius: ${Shapes.borderRadius}px;
`
type UnavailableCardContentProps = {
  message: string
}
export const UnavailableCardContent = (props: UnavailableCardContentProps) => {
  const { message } = props
  return (
    <Wrapper>
      <Content>
        <Telescope size={48} color={Colors.textLight} />
        <Typography variant="title2" color={Colors.textDark}>
          {message}
        </Typography>
      </Content>
    </Wrapper>
  )
}
